import { defineMessages } from 'react-intl';

export default defineMessages({
  addCategoryPopoverTitle: {
    description: 'Add Reporting Category Popover',
    defaultMessage: 'Add Product Category',
    id: 'DsMkYz',
  },
  addCategoryButton: {
    description: 'Add Reporting Category Button',
    defaultMessage: 'Add Product Category',
    id: 'pMnFKD',
  },
  cancelCategoryEditButton: {
    description: 'Reporting Category Cancel Button',
    defaultMessage: 'Cancel',
    id: 'YZBLV5',
  },
  deleteCategoryButton: {
    description: 'Reporting Category Delete Button',
    defaultMessage: 'Delete',
    id: 'bqKi8+',
  },
  saveCategoryButton: {
    description: 'Reporting Category Save Button',
    defaultMessage: 'Save',
    id: 'PElJZy',
  },
  editCategoryButton: {
    description: 'Reporting Category Edit Button',
    defaultMessage: 'Edit',
    id: '61c8aW',
  },
  actionsColumn: {
    description: 'Reporting Category Actions Column',
    defaultMessage: 'Actions',
    id: 'wMMJLg',
  },
  nameColumn: {
    description: 'Reporting Category Name Column',
    defaultMessage: 'Name',
    id: 'lR8h5X',
  },
  numberOfProductsColumn: {
    description: 'Reporting Category Number of Products Column',
    defaultMessage: '# of Products',
    id: 'aostSV',
  },
  deleteModalHeader: {
    description: 'Reporting Category Confirm Delete Modal Header',
    defaultMessage: 'Delete Reporting Category',
    id: 'ysu5iK',
  },
  deleteModalWarning: {
    description: 'Reporting Category Confirm Delete Warning Message',
    defaultMessage: 'Confirm Reporting Category deletion, this cannot be undone',
    id: 'fOO8Ly',
  },
  deleteModalConfirmation: {
    description: 'Reporting Category Confirm Delete Confirm',
    defaultMessage: 'Confirm Deletion',
    id: 'F4HYxw',
  },
  reportingCategoryGridLabel: {
    description: 'Reporting Categories view label',
    defaultMessage: 'Reporting Categories',
    id: '2IvmgU',
  },
});
